import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { HeaderComponent } from "../../../../components/header/header.component";

@Component({
    selector: "app-too-expensive",
    templateUrl: "./too-expensive.component.html",
    styleUrls: ["./too-expensive.component.scss"],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        TranslatePipe,
    ],
})
export class TooExpensiveComponent implements OnInit {
  pageTitle = "Leave syndicate";
  reason = "too-expensive";
  syndicateName: any;
  constructor(private modalCtrl: ModalController, private navParams: NavParams,
    public translate: TranslateService,
    private GTMSegment: GTMSegmentService) {
    this.GTMSegment.GTMPopupInitialization("leaveSyndicateReasonPopup-3");
  }

  ngOnInit() {
    this.syndicateName = this.navParams?.data?.s_name
    this.translate.get(['too-expensive.pageTitle']).subscribe((res: string) => {
      this.pageTitle = (res["too-expensive.pageTitle"])
    }, err => { return (err) })
  }

  backToLeaveSyndicate() {
    this.modalCtrl.dismiss().catch(err => { return err });
  }

  leave() {
    this.modalCtrl.dismiss(this.reason).catch(err => { return err });
  }

  pauseSyndicate() {
    const reason = {
      pauseSyndicate: true,
    };
    this.modalCtrl.dismiss(reason).catch((err) => {
      return err;
    });
  }
}
